<template>
  <table class="profile-block__history history-table" v-if="orders.length">
    <tr>
      <th class="history-table__num">№</th>
      <th class="history-table__date">Дата</th>
      <th class="history-table__adres">Адрес</th>
      <th class="history-table__price">Сумма</th>
      <th class="history-table__status">Статус</th>
    </tr>
    <tr v-for="order in orders" :key="order.ID">
      <td class="history-table__num" data-label="№">
        <p>
          <router-link :to="{'name': 'order-history-detail', params: {'orderId': order.ID}}">{{order.ID}}</router-link>
        </p>
        <p>{{order.PAY_SYSTEM_NAME}}</p>
      </td>
      <td class="history-table__date" data-label="Дата">{{order.DATE_INSERT}}</td>
      <td class="history-table__adres" data-label="Адрес">
        <p>{{order.ADDRESS.LOCATION.DISPLAY}}</p>
        <p>ул. {{order.ADDRESS.STREET}},</p>
        <p>д. {{order.ADDRESS.HOUSE}}{{ order.ADDRESS.BUILDING ? ` к. ${order.ADDRESS.BUILDING}` : ''}}{{ order.ADDRESS.APARTMENTS ? `, кв. ${order.ADDRESS.APARTMENTS}` : ''}}</p>
      </td>
      <td class="history-table__price" data-label="Сумма" v-html="order.TOTAL_PRICE_FORMATTED"></td>
      <td class="history-table__status" data-label="Статус">{{order.STATUS_NAME}}</td>
    </tr>
  </table>
  <p v-else-if="ordersLoaded && !orders.length">У вас нет ни одного заказа</p>
  <p v-else-if="!ordersLoaded">Загрузка заказов...</p>
</template>

<script>
import api from '@/api/personal'

export default {
  name: 'ProfileOrderHistory',
  data: function () {
    return {
      orders: {
        type: Array,
        default: function () {
          return [];
        }
      },
      ordersLoaded: false,
    };
  },
  components: {
  },
  computed: {

  },
  watch: {

  },
  beforeMount() {
    api.loadOderHistory(response => {
      this.orders = response.data.orders;
      this.ordersLoaded = true;
    });
  }
}
</script>